<template>
	<div class="personMenu">
		<div class="w">
	    	<div class="item" v-for="item in menu" :class="{on : item.path == isSelect}">
				<router-link :to="item.path">
					<img :src="isSelect === item.path ? item.curicon : item.icon" alt="">
					{{item.name}}
				</router-link>
	    	</div>
    	</div>
    </div>
</template>
<script>
export default {
	name: 'personmenu',
	data(){
		return{
			menu:[{
				id:'1',
				name: '用户首页', 
				icon: `${require("@/assets/images/person1.png")}`,
				curicon: `${require("@/assets/images/person01.png")}`,
				path:"/person/index"
			},{
				id:'8',
				name: '实名认证', 
				icon: `${require("@/assets/images/person7.png")}`,
				curicon: `${require("@/assets/images/person07.png")}`,
				path:"/person/information"
			},{
				id:'2',
				name: '加入协会', 
				icon: `${require("@/assets/images/person2.png")}`,
				curicon: `${require("@/assets/images/person02.png")}`,
				path:"/person/account"
			},{
				id:'3',
				name: '账户安全', 
				icon: `${require("@/assets/images/person3.png")}`,
				curicon: `${require("@/assets/images/person03.png")}`,
				path:"/person/safe"
			},{
				id:'4',
				name: '消息中心', 
				icon: `${require("@/assets/images/person4.png")}`,
				curicon: `${require("@/assets/images/person04.png")}`,
				path:"/person/message"
			},{
				id:'5',
				name: '用户收藏', 
				icon: `${require("@/assets/images/person5.png")}`,
				curicon: `${require("@/assets/images/person05.png")}`,
				path:"/person/collect"
			},{
				id:'6',
				name: '投诉建议', 
				icon: `${require("@/assets/images/person6.png")}`,
				curicon: `${require("@/assets/images/person06.png")}`,
				path:"/person/suggestion"
			},{
				id:'7',
				name: '我的发布', 
				icon: `${require("@/assets/images/person7.png")}`,
				curicon: `${require("@/assets/images/person07.png")}`,
				path:"/person/supply"
			}],
			isSelect:"用户首页"
		}
	},
	mounted(){
		this.isSelect=this.$route.path
	},
	activated(){
	},
	computed:{
		
	},
	methods: {
		
   	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/personmenu/index.vue